export class UserInfo {
    isAuthenticated: boolean;
    claims: {type: string, value: string}[];
}
